module.exports = __webpack_public_path__ + "img/monograph-publication.1330ed55.png";